import { useEffect, useRef, useState } from "react";
import { useDesignCards } from "../context/DesignCardsContext";

export default function DesignNavbar() {
  const navbarRef = useRef(null);
  const { step, setStep, isEnded } = useDesignCards();
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (navbarRef.current) {
        const { top } = navbarRef.current.getBoundingClientRect();

        if (top <= 0 && !isFixed) setIsFixed(true);
        if (top > 0 && isFixed) setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFixed]);

  const handleClick = (step) => {
    const section = document.getElementById(`design-section-${step}`);
    if (section) {
      setStep(step);
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="xpb-design__navbar-container" ref={navbarRef}>
      <nav
        className={`xpb-design__navbar ${isFixed ? "fixed" : ""} ${
          isEnded ? "ended" : ""
        }`}
      >
        <ul>
          <li>
            <button
              onClick={() => handleClick(1)}
              style={{ opacity: step === 1 ? 1 : 0.6 }}
            >
              <figure aria-label="1" /> Investigar
            </button>
          </li>
          <li>
            <button
              onClick={() => handleClick(2)}
              style={{ opacity: step === 2 ? 1 : 0.6 }}
            >
              <figure aria-label="2" /> Crear
            </button>
          </li>
          <li>
            <button
              onClick={() => handleClick(3)}
              style={{ opacity: step === 3 ? 1 : 0.6 }}
            >
              <figure aria-label="3" /> Construir
            </button>
          </li>
          <li>
            <button
              onClick={() => handleClick(4)}
              style={{ opacity: step === 4 ? 1 : 0.6 }}
              href="#design-section-4"
            >
              <figure aria-label="4" /> Armar
            </button>
          </li>
          <li>
            <button
              onClick={() => handleClick(5)}
              style={{ opacity: step === 5 ? 1 : 0.6 }}
            >
              <figure aria-label="5" /> Evaluar
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}
